import React from 'react';
import { Modal, Result, Button } from 'antd';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { handleModifyCatalogue } from '../../../services/utils/catalogueModificationUtils';

const ConfirmClosePublishedModal = ({
    modalState,
    setModalState,
    isDraftSavable,
    currentPublishedCatalogueId,
    draftFormData,
    fetchCatalogues,
    messageApi,
    statusTokens,
    formInstance, // Add formInstance to get the latest form values
    existingDraftId // Add existing draft ID
}) => {

    return (
        <Modal
            open={modalState === 'closePublishedConfirm'}
            onCancel={() => setModalState('closed')}
            centered
            footer={null}
        >
            <Result
                icon={<WarningAmberIcon style={{ color: statusTokens.warning, fontSize: 64 }} />}
                title="Do you want to save your changes before closing?"
                extra={[
                    <Button
                        key="save"
                        type="primary"
                        disabled={!isDraftSavable}
                        onClick={async () => {
                            try {
                                // Get current form data (this has the latest changes)
                                const currentFormData = formInstance.getFieldsValue(true);

                                // Use current form data (handleModifyCatalogue will process the images)
                                await handleModifyCatalogue({
                                    formData: currentFormData, // This has the latest changes but needs image processing
                                    form: formInstance,
                                    originalCatalogueId: currentPublishedCatalogueId,
                                    existingDraftId: existingDraftId,
                                    messageApi,
                                    onSuccess: () => {
                                        setModalState('closed');
                                        fetchCatalogues(true);
                                    }
                                });
                            } catch (error) {
                                // Error handling is already done in the utility function
                                // Just prevent the modal from closing if there's an error
                            }
                        }}
                    >
                        Save Changes
                    </Button>,
                    <Button key="discard" onClick={() => {
                        setModalState('closed');
                        messageApi.info('Changes discarded.');
                        // Refresh the catalog list to update UI
                        fetchCatalogues(true);
                    }}>
                        Discard Changes
                    </Button>,
                    <Button key="cancel" type="link" onClick={() => setModalState('modifyPublished')}>
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    )
}

export default ConfirmClosePublishedModal;